<template>
  <!--
    The one way back every Next Steps encryption screen offers (#1693, #1694).

    A manual pass on 2026-09-10 found six of them with no way off but the
    system gesture — which the web build does not have, and which is not
    discoverable on either. `Devices.vue` had fixed this for itself in #1749;
    this is that fix as a component, so the seventh screen cannot forget it.

    Thin on purpose: the shared `BackButton` does the navigating (history first,
    then `fallbackRoute`), and the theme variant follows the Next Steps dark
    flag the same way the Hub's does. `customBack` is for a screen where going
    back MEANS something — the rotation's confirm step hands it to the same
    `cancel` its text link fires, so the two cannot drift.
  -->
  <BackButton
    compact
    disable-safe-area
    :variant="isDark ? 'on-dark' : 'default'"
    :fallback-route="fallbackRoute"
    :disabled="disabled"
    :custom-back="customBack"
    class="mb-6 shrink-0 self-start"
  />
</template>

<script>
import BackButton from '@/components/common/BackButton.vue';
import { ENCRYPTION_ROUTES } from '@/constants/courses-encryption';
import coursesTheme from '@/mixins/CoursesTheme';

export default {
  name: 'CoursesBackButton',
  components: { BackButton },
  mixins: [coursesTheme],
  props: {
    /** Where a deep-linked member with no history goes: the Devices screen, which every one of these hangs off. */
    fallbackRoute: { type: [String, Object], default: ENCRYPTION_ROUTES.devices },
    disabled: { type: Boolean, default: false },
    customBack: { type: Function, default: null },
  },
};
</script>
